/**
 * Public Layout
 *
 * Simple layout wrapper for public pages (login).
 * No authentication required.
 */

import { Outlet } from 'react-router-dom';

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-surface-muted">
      <Outlet />
    </div>
  );
}
